import { Fragment } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

function Saleschannels({ sale_channel }) {
    const { t } = useTranslation();

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Sales Channels")}</h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="d-flex align-items-center gap-5">
                        <div className="d-flex flex-column">
                            <div className="bg-info text-white al-border-radius-8 bg-opacity-75 min-w-125px py-10 px-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="fw-semibold fs-6">
                                    {"GMV"}
                                    <i className="ki-outline ki-question-2 fs-3 text-white ms-1 al-vertical-align-middle" data-tooltip-id="my-tooltip" data-tooltip-content={t("Shop's own sales + Influencer sales + Others")}></i>
                                </div>
                                <div className="fs-2 fw-bold counted">{sale_channel?.all?.total_sale_gmv_amt}</div>
                                <div className="fs-5 fw-bold counted">&nbsp;</div>
                            </div>
                        </div>
                        <div className="d-flex flex-column">
                            =
                        </div>
                        <div className="d-flex flex-row flex-grow-1">
                            <div className="d-flex flex-column">
                                <div className="bg-success text-white al-border-radius-8 bg-opacity-75 min-w-125px py-10 px-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center" style={{ borderTopRightRadius: "0px", borderBottomRightRadius: "0px"}}>
                                    <div className="fw-semibold fs-6">
                                        {"Own account"}
                                        <i className="ki-outline ki-question-2 fs-3 text-white ms-1 al-vertical-align-middle" data-tooltip-id="my-tooltip" data-tooltip-content={t("Sales from the shop's own account.")}></i>
                                    </div>
                                    <div className="fs-2 fw-bold counted">{sale_channel?.self_support?.total_sale_gmv_amt}</div>
                                    <div className="fs-5 fw-bold counted">{sale_channel?.self_support?.gmv_rate}</div>
                                </div>
                            </div>
                            <div className="d-flex flex-column flex-grow-1">
                                <div className="bg-danger text-white al-border-radius-8 bg-opacity-75 min-w-125px py-10 px-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center" style={{ borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px"}}>
                                    <div className="fw-semibold fs-6">
                                        {"Affiliate influencer sales"}
                                        <i className="ki-outline ki-question-2 fs-3 text-white ms-1 al-vertical-align-middle" data-tooltip-id="my-tooltip" data-tooltip-content={t("Sales from affiliate influencers.")}></i>
                                    </div>
                                    <div className="fs-2 fw-bold counted">{sale_channel?.sell_product?.total_sale_gmv_amt}</div>
                                    <div className="fs-5 fw-bold counted">{sale_channel?.sell_product?.gmv_rate}</div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-column">
                            +
                        </div>
                        <div className="d-flex flex-column flex-grow-1">
                            <div className="bg-info text-white al-border-radius-8 bg-opacity-75 min-w-125px py-10 px-6 mb-3 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="fw-semibold fs-6">
                                    {"Other"}
                                    <i className="ki-outline ki-question-2 fs-3 text-white ms-1 al-vertical-align-middle" data-tooltip-id="my-tooltip" data-tooltip-content={t("Sales from showcase, product cards etc.")}></i>
                                </div>
                                <div className="fs-2 fw-bold counted">{sale_channel?.shop_mall?.total_sale_gmv_amt}</div>
                                <div className="fs-5 fw-bold counted">{sale_channel?.shop_mall?.gmv_rate}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Saleschannels);